import React from 'react';

const Header = ({ value }: { value: string }) => {
  return <div style={{ fontSize: '1.2rem', color: '#FFFFFF' }}>{value}</div>;
};

export default Header;
